export enum ESocketEvent {
  Requests = 'requests',
  Supplies = 'supplies',
  RequestHistories = 'request-histories',
  ContractSync = 'contract-sync',
}
